// i18next-extract-mark-ns-start CoutureServices
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import {
  tabletThresholdPixels, mobileThresholdPixels, frames, LittleTitle, margins,
} from './home/v4/styledComponents';
import { slashNtoBr } from '../services/formatting';

const Container = styled.div`
  margin: ${margins.m8} auto 0;
  width: 834px;
  text-align: center;
  @media (max-width: ${tabletThresholdPixels}) {
    margin: ${margins.m8} ${frames.tablet};
    width: unset;
    max-width: 834px;
  }
  @media (max-width: ${mobileThresholdPixels}) {
    margin: ${margins.m5} ${frames.mobile};
    width: unset;
  }
`;

const Text = styled.p`
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
`;

type FormattedSpanProps = {
  isBold: boolean;
};
const FormattedSpan = styled.span<FormattedSpanProps>`
  ${({ isBold }) => isBold && 'font-weight: 500;'}
`;

/* eslint-disable react/no-array-index-key */
export const toFormattedBoldAndSlashNtoBr = (text: string) => {
  const splitText = text.split('<bold>').filter((line) => line !== '');
  return splitText.map((line, index) => (
    <FormattedSpan key={`${line}${index}`} isBold={index % 2 !== 0}>
      {slashNtoBr(line)}
    </FormattedSpan>
  ));
};

type IntroTexts = {
  [key: string]: string;
};

interface IntroProps {
  work: string;
  title: string;
}

function Intro({ work, title }: IntroProps) {
  const { t } = useTranslation();

  const getIntroTexts = (): IntroTexts => ({
    // eslint-disable-next-line max-len
    couture: t('Nos couturiers et couturières retouchent et réparent tous vos vêtements, accessoires et éléments de décoration. Prolongez la durée de vie de votre dressing grâce au savoir-faire de nos experts : retouche et couture, ourlet de pantalon, réparation de fermeture éclaire, ourlet de rideau, upcycling…'),
    // eslint-disable-next-line max-len
    leatherGoods: t('Nos artisans maroquiniers prennent soin de tous vos sacs qu’ils soient en cuir, en daim ou en toile. Prolongez la durée de vie de vos sacs grâce au savoir-faire de nos experts :  nettoyage, teinture, entretien, réparation de fermeture…'),
    // eslint-disable-next-line max-len
    embroidery: t('Nos artisans brodeurs vous conseillent, vous donnent des idées et réalisent des broderies sur tous vos vêtements et textiles. Créez ou offrez une broderie personnalisée grâce au savoir-faire de nos experts : broderie sur un sweat, sur du jean, sur un plaid, broderie de prénom, broderie de motif…'),
    // eslint-disable-next-line max-len
    tilliste: t('Des hommes et des femmes uniques rassemblés autour de la même passion : <bold>l’artisanat !<bold>\nDes artisans passionnés, amoureux du travail bien fait et qui ont à coeur de transmettre leur savoir-faire. Des personnalités attentives, qui sauront satisfaire toutes les demandes de façon précise et bienveillante.\n Une palette complète de savoir-faire : nos couturiers, brodeurs, maroquiniers et cordonniers partagent le même objectif, celui de faire perdurer tous les objets du quotidien.'),
    // eslint-disable-next-line max-len
    shoes: t('Nos artisans cordonniers prennent soin de toutes vos chaussures qu’elles soient en cuir, en daim ou en toile. Prolongez la durée de vie de vos chaussures grâce au savoir-faire de nos experts :  nettoyage, cirage, pose de patin, remplacement de semelles...'),
    // eslint-disable-next-line max-len
    artisan: t('Vous souhaitez confier à un artisan votre produit pour qu’il puisse en prendre soin et le faire perdurer dans le temps. Retrouvez chez Tilli plus de 500 artisans français pour vous accompagner dans la restauration et la réinvention de ces biens. '),
  });

  return (
    <Container>
      <LittleTitle>{slashNtoBr(title)}</LittleTitle>
      <Text>{toFormattedBoldAndSlashNtoBr(getIntroTexts()[work])}</Text>
    </Container>
  );
}

export default Intro;
